import React from 'react'
import { ReactComponent as Icon } from 'src/Resources/Images/LiveView/AlternativeView/inactive-ai360.svg'

export const InactiveAi360LabelIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return <Icon viewBox="0 0 65 25" {...props} fill="currentColor" />
}
